import React from 'react';
import { createRoot } from 'react-dom/client';

import { AppProvider } from '@/shared/duck';

import App from './app.tsx';

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AppProvider>
      <App />
    </AppProvider>
  </React.StrictMode>,
);
